var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElections = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 37 37",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.608 31.858h-3.952V17.31c-2.26.97-4.353 1.866-4.535 1.943l-.014.006-.016.007a3.7 3.7 0 0 1-1.393.274 3.59 3.59 0 0 1-3.344-2.233c-.756-1.858.115-3.976 1.943-4.73l1.774-.759h-7.084v20.039h-3.95a1.08 1.08 0 0 0 0 2.16h20.57a1.08 1.08 0 1 0 0-2.16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m33.585 6.833-4.112-3.978a.97.97 0 0 0-1.213-.068l-1.653 1.112h-.188c-1.123 0-6.955.055-8.476 1.18 0 0-1.82 1.282-3.404 3.17-.539.64-.944 1.213-1.247 1.72h8.562c.539 0 .978.505.91 1.078a2.09 2.09 0 0 1-1.28 1.754l-3.472 1.483c-.91.37-1.315 1.416-.945 2.325a1.75 1.75 0 0 0 1.631 1.082c.232 0 .468-.045.695-.137 0 0 9.372-4.012 10.281-4.416.304-.135 1.55-1.012 1.955-1.921.54-1.18 1.45-2.394 2.024-3.101.303-.405.27-.945-.068-1.282z"
  })));
};
export default SvgElections;